import React from "react"
import PropTypes from "prop-types"
import { Flex } from "antd"
import { ExperienceListingIcon } from "ui/Icon/DSIcon/ExperienceListing"
import { ExperienceTableIcon } from "ui/Icon/DSIcon/ExperienceTable"
import styles from "../index.module.css"

const ICON_COLOR_ACTIVE = "var(--color-primary)"
const ICON_COLOR_INACTIVE = "#A8A9AA"

const ViewToggleButton = ({ active, onClick, children }) => (
  <Flex
    justify="center"
    align="center"
    onClick={onClick}
    className={active ? styles.listingTabActive : styles.listingTabInactive}
  >
    {children}
  </Flex>
)

ViewToggleButton.propTypes = {
  active: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired
}

const ViewToggle = ({ selectedListing, onChange }) => (
  <Flex justify="center" align="center" className={styles.viewTogglePill}>
    <ViewToggleButton active={selectedListing === "table"} onClick={() => onChange("table")}>
      <ExperienceTableIcon color={selectedListing === "table" ? ICON_COLOR_ACTIVE : ICON_COLOR_INACTIVE} />
    </ViewToggleButton>
    <ViewToggleButton active={selectedListing === "listing"} onClick={() => onChange("listing")}>
      <ExperienceListingIcon color={selectedListing === "listing" ? ICON_COLOR_ACTIVE : ICON_COLOR_INACTIVE} />
    </ViewToggleButton>
  </Flex>
)

ViewToggle.propTypes = {
  selectedListing: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
}

export default ViewToggle
